import { Link } from "react-router-dom";
import "./index.scss";
import Loader from "react-loaders";
import React from "react";
import image from '../../assets/images/profileImg.png'


//change logo later
const Home = () => {
  

  return (
    <>
      <div className="homeContainer home-page">
        <div className="text-zone">
          <h1>
            Hi there!
          </h1>
          <h3>I am Lucky the developer from Vancouver, BC Canada.</h3>
          <h3>Background is in Graphic Design and Photography </h3>
          <h3>Let me build your amazing websites for YOU</h3>
          <h3>Click <span><Link to='/about'>HERE</Link> </span>to learn more about me!</h3>
          <h2>Full Stack Developer / Javascript Expert / Cat Mom</h2>
          <Link to="/contact" className="flat-button">
            CONTACT ME
          </Link>
        </div>
        <div className="img">
          <img src={image} alt="" />
        </div>
      </div>
      <Loader type="pacman" />
    </>
  );
};

export default Home;
